








































/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from '@/plugins/axios';
import Vue from 'vue';
import { API_GET_SELECT_ORDER_NO } from '@/constants/api';
import { API_GET_SELECT_ORDER_CODE } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlOrderInquiry',
  props: {
    setFirstChar: { type: String, default: '' },
    setSecondChar: { type: String, default: '' },
    orderNo: { type: String, default: '' },
    jigyoshoCd: { type: Number },
    himmokuCd: { type: Number },
    numGetBtnShow: { type: Boolean, default: true },
    readonly: { type: Boolean, default: false },
    label: { type: String, default: 'オーダー№' },
  },
  watch: {
    orderNo() {
      this.separateNo();
    },
    setSecondChar(newVal) {
      this.secondChar = newVal;
      this.setData = {
        value: newVal,
        text: newVal,
      };
      // #889711 各入力画面で編集で起動した場合にオーダーNOが変更できてしまう
      // this.btnAvailable = false;
      if (!this.orderNo) this.btnAvailable = false;
    },
  },
  data: () => ({
    firstChar: '',
    secondChars: [],
    secondChar: '',
    orderNum: '',
    btnAvailable: true,
    setData: {
      orderNoEiji: '',
    },
    itemText: 'orderNoEiji',
  }),
  methods: {
    getNumber() {
      if (this.firstChar != '' && this.localState != undefined) {
        this.orderNum = '';
      }
      axios
        .get(API_GET_SELECT_ORDER_NO, {
          params: {
            orderSaibanCd: this.firstChar + this.secondChar,
            jigyoshoCd: this.jigyoshoCd,
            himmokuCd: this.himmokuCd,
          },
        })
        .then((res) => {
          if (!res.data.orderNo) {
            console.log('Cannot get order no');
            this.errors = noDataError();
            return;
          }
          this.errors = clearNoDataError();
          const text = res.data.orderNo.replace(/[^0-9]/g, '');
          this.orderNum = text;
          this.btnAvailable = true;
          this.emitData();
          this.callbackOk && this.callbackOk(res.data);
        });
    },
    clearAll() {
      this.orderNum = '';
      this.btnAvailable = true;
      this.emitData();
    },
    clearNumber() {
      this.orderNum = '';
      this.btnAvailable = false;
    },
    generateSelect() {
      // Backend からデータを取得
      axios
        .get(API_GET_SELECT_ORDER_CODE, {
          params: {
            daibunruiCd: this.daibunruiCd,
            mukoUmuFlg: this.mukoUmuFlg,
          },
        })
        .then((res) => {
          if (!res.data.responseData) {
            this.secondChars = [];
            this.errors = noDataError();
            return;
          }
          this.errors = clearNoDataError();
          // const secondChars = res.data;
          const text = res.data.responseData;
          this.secondChars = text;
          this.callbackOk && this.callbackOk(res.data);
        });
    },
    changeSelect(item: string, event: any) {
      this.secondChar = event;
      this.clearNumber();
      this.emitData();
    },
    separateNo() {
      if (this.checkNo(this.orderNo)) {
        this.firstChar = this.orderNo.charAt(0);
        this.secondChar = this.orderNo.charAt(1);
        this.setData = {
          value: this.secondChar,
          text: this.secondChar,
        };
        this.orderNum = this.orderNo.slice(2, 7);
        this.btnAvailable = true;
      } else {
        this.orderNum = '';
        this.secondChar = this.setSecondChar;
      }
      this.emitData();
    },
    checkNo(str: string) {
      const reg = new RegExp(/^[A-Za-z]{2}[0-9]{5}$/);
      const res = reg.test(str);
      return res;
    },
    emitData() {
      this.$emit('emitData', this.firstChar, this.secondChar, this.orderNum);
    },
  },
  created() {
    this.generateSelect();
    this.firstChar = this.setFirstChar;
    if (this.setSecondChar) {
      this.secondChar = this.setSecondChar;
      this.setData = {
        value: this.secondChar,
        text: this.secondChar,
      };
      this.btnAvailable = false;
    }
    if (this.orderNo) this.separateNo();
    if (this.readonly) {
      this.selectAvailable = true;
    }
  },
});
